import {useState, useRef, useEffect} from 'react'
import {BirthdayMember} from '../../types/birthdays'
import {BirthdayTooltip} from './BirthdayTooltip'
import './BirthdayIcon.css'

interface BirthdayIconProps {
  birthday: BirthdayMember
  onOpenPreview?: (id: string) => void
}

export const BirthdayIcon = ({birthday, onOpenPreview}: BirthdayIconProps) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const [tooltipPosition, setTooltipPosition] = useState({top: 0, left: 0})
  const iconRef = useRef<HTMLDivElement>(null)

  const firstName = birthday.firstName.split(' ')[0]
  const lastName = birthday.lastName.split(' ')[0]

  useEffect(() => {
    if (showTooltip && iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect()
      const estimatedWidth = 260 // matches tooltip max-width-ish
      const spacing = 5
      let left = rect.right + spacing

      if (left + estimatedWidth > window.innerWidth) {
        left = Math.max(10, rect.left - estimatedWidth - spacing)
      }

      const top = Math.max(10, rect.top - 10)

      setTooltipPosition({
        top,
        left,
      })
    }
  }, [showTooltip])

  return (
    <>
      <div
        ref={iconRef}
        className='birthday-icon'
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={() => onOpenPreview?.(birthday.id)}
        title={`${firstName} ${lastName}`}
      >
        <i className='bi bi-cake2-fill'></i>
        <span className='birthday-icon-name'>
          {firstName} {lastName}
        </span>
        {birthday.memberRol && (
          <span className={`birthday-rol-badge birthday-rol-badge--${birthday.memberRol.toLowerCase()}`}>
            {birthday.memberRol}
          </span>
        )}
      </div>
      {showTooltip && (
        <div
          style={{
            position: 'fixed',
            top: tooltipPosition.top,
            left: tooltipPosition.left,
            zIndex: 1100,
          }}
        >
          <BirthdayTooltip birthday={birthday} />
        </div>
      )}
    </>
  )
}
